import BaseCountry from 'registration/js/base/fields/country_code';

import template from 'registration/templates/new/fields/country_code.html';

const CountryCodeField = BaseCountry.extend({
    template,
});

export default CountryCodeField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/new/fields/country_code.js